import { Button } from "../../components/Button";
import "./PdfGenerator.css";
import downloadIcon from "../../icons/move-layer-down.svg";
import pdfIndexIcon01 from "../../icons/container-156.svg";
import pdfIndexIcon02 from "../../icons/container-157.svg";
import { payment, enrollment } from "../../store";
import { certificate } from "../../store";
import { useEffect, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { CertificateDocument } from "./CertificateDocument";
import { generateAndDownloadCertificatePDF } from "./certificatePdfUtils";

// 결제 상태별 관리자용 설명.
// "결제중(READY)"이 진행 중인지·실패인지·이탈인지 운영자가 바로 파악하도록 안내한다.
const STATUS_DESCRIPTION = {
  READY: "고객이 결제창에서 승인을 완료하지 않은 상태입니다. 결제 진행 중이거나 중간에 이탈했을 수 있습니다.",
  IN_PROGRESS: "결제가 처리 중입니다.",
  WAITING_FOR_DEPOSIT: "가상계좌 입금을 기다리는 중입니다.",
  DONE: "결제가 정상 완료되었습니다.",
  COMPLETED: "결제가 확인되었습니다.",
  ABORTED: "결제가 실패했습니다. (카드 거절·한도 초과 등)",
  EXPIRED: "결제창에서 승인 없이 종료되어 만료된 건입니다. (고객 이탈 추정)",
  CANCELED: "결제 후 취소·환불된 건입니다.",
  PARTIAL_CANCELED: "결제 후 부분 취소된 건입니다.",
};
/*
//영수증 저장하기 버튼 관련 로직 시작작
const receiptPDF = async (payment_id) => {
  const input = document.getElementById(`order-receipt-${payment_id}`);
  const canvas = await html2canvas(input, {
    scale: 1,
    useCORS: true,
  });

  const pdfWidth = 595.28;
  const pdfHeight = 841.89;

  const canvasRatio = canvas.height / canvas.width;
  const pdfRatio = pdfHeight / pdfWidth;
  let ratio = 1;
  if (canvasRatio > pdfRatio) {
    ratio = pdfHeight / canvas.height;
  } else {
    ratio = pdfWidth / canvas.width;
  }

  const pdf = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: [pdfWidth, pdfHeight],
  });

  const imgWidth = canvas.width * ratio;
  const imgHeight = canvas.height * ratio;

  const imgData = canvas.toDataURL("image/png");
  pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

  pdf.save("영수증.pdf");
};
// 영수증 저장하기 버튼 관련 로직 끝(주석 처리)
*/
export const PdfGenerator = () => {
  let {certificate_id} = useParams();

  const {getCertificate, certificate:certificateData, clearCertificate, updateCertificate} = certificate((state=>({getCertificate: state.getCertificate, certificate: state.certificate, clearCertificate: state.clearCertificate, updateCertificate: state.updateCertificate})))

  useEffect(() => {
    clearCertificate();
    getCertificate(certificate_id);
  }, [certificate_id, clearCertificate, getCertificate]);

  const handleGenerateAndDownload = async () => {
    await generateAndDownloadCertificatePDF(certificate_id);
    
    if (certificateData && certificateData.user_name && !certificateData.issued_date && !certificateData.is_issued) {
      const updateData = {
        user_name: certificateData.user_name,
        issued_date: certificateData.issued_date,
        is_issued: true
      };
      
      try {
        await updateCertificate(certificate_id, updateData);
      } catch (error) {
        console.error("함수 발행 여부 변경이 실패했습니다:", error);
      }
    }
  };

  return (
    <div className="pdf-generator">
      <Button
        label="저장하기"
        onClick={handleGenerateAndDownload}
        style={{ alignSelf: "end", marginTop: "20px" }}
      >
        <img
          className="move-layer-down"
          alt="저장하기"
          src={downloadIcon}
        />
      </Button>

      <CertificateDocument
        certificateData={certificateData}
        certificateId={certificate_id}
      />
    </div>
  );
};


export const ReceiptPdfGenerator = () => {
  const { order_id } = useParams();
  const getPaymentByOrderId = payment((state) => state.getPaymentByOrderId);
  const paymentData = payment((state) => state.payment);
  const isLoading = payment((state) => state.isLoading);
  // const cancelPayment = payment((state) => state.cancelPayment);
  // const deleteEnrollment = enrollment((state) => state.deleteEnrollment)
  // const getIsEnrolled = enrollment((state)=> state.getIsEnrolled)
  // const enrollmentData = enrollment((state)=> state.enrollment)

  useEffect(() => {
    const fetchPayment = async () => {
      await getPaymentByOrderId(order_id);
    };
    fetchPayment();
  }, [getPaymentByOrderId, order_id]);

  // const handleCancel = async () => {
  //   const paymentKey = paymentData?.payment_key;
  //   const purchaserUserId = paymentData?.user_id;
  //   const purchaserCourseId = paymentData?.course_id;
  
  //   if (paymentKey) {
  //     const confirmCancel = window.confirm("정말로 결제를 취소하시겠습니까?");
  //     if (confirmCancel) {
  //       try {
  //         // 결제 취소
  //         await cancelPayment(paymentKey, "관리자에 의한 결제 취소", paymentData?.amount);
          
  //         // 등록 정보 확인
  //         const enrollmentInfo = await getIsEnrolled(purchaserUserId, purchaserCourseId);
          
  //         if (enrollmentInfo && enrollmentInfo.id) {
  //           // 등록 삭제
  //           await deleteEnrollment(enrollmentInfo.id);
  //           alert("결제가 취소되고 수강 등록이 삭제되었습니다.");
  //         } else {
  //           alert("결제는 취소되었지만, 수강 등록 정보를 찾을 수 없습니다.");
  //         }
  //       } catch (error) {
  //         console.error("Error during cancellation process:", error);
  //         if (error.response && error.response.status === 404) {
  //           alert("결제 정보를 찾을 수 없습니다.");
  //         } else if (error.message === "ALREADY_CANCELED_PAYMENT") {
  //           alert("이미 취소된 결제입니다.");
  //         } else {
  //           alert("결제 취소 중 오류가 발생했습니다. 관리자에게 문의해주세요.");
  //         }
  //       }
  //     }
  //   } else {
  //     alert("결제 키 정보가 없습니다. 관리자에게 문의해주세요.");
  //   }
  // };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="order-title-wrap">
        <h2 className="order-title">결제상세</h2>
          {/* <div className="order-buttons">
       
          //영수증 저장하기 버튼 jsx 시작
          <Button
            label="영수증 저장하기"
            onClick={() => receiptPDF(order_id)}
            style={{
              height: "36px",
              padding: "auto 16px",
              fontSize: "14px",
            }}
          >
            <img
              className="move-layer-down"
              alt="저장하기"
              src={downloadIcon}
            />
          </Button>*/}
          {/* <Button
            label="결제 취소하기"
            style={{ height: "36px", padding: "auto 16px", fontSize: "14px" }}
            onClick={handleCancel}
          ></Button> 
          //영수증 저장하기 버튼 jsx 끝
          
        </div>*/}
      </div>
      <div className="order-receipt-wrap">
        <div className="order-receipt" id={`order-receipt-${order_id}`}>
          <div className="order-receipt-info">
            <div className="order-receipt-index-wrap">
              <img src={pdfIndexIcon01} alt="결제 방법" />
              <h4 className="order-receipt-index">결제 정보</h4>
            </div>
            <table className="order-receipt-info-table">
              <tbody>
                <tr>
                  <td>결제금액</td>
                  <td>{paymentData?.amount}</td>
                </tr>
                <tr>
                  <td>부가세</td>
                  <td>{(paymentData?.amount * 0.1).toFixed(0)}</td>
                </tr>
                <tr>
                  <td>할인액</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td className="order-receipt-info-value-strong">
                    {paymentData?.amount}
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td>결제일</td>
                  <td>{new Date(paymentData?.created_at).toLocaleString()}</td>
                </tr>
                <tr>
                  <td>구매자</td>
                  <td>{paymentData?.user_name}</td>
                </tr>
                <tr>
                  <td>결제번호</td>
                  <td>#{paymentData?.payment_id}</td>
                </tr>
                <tr>
                  <td>할부</td>
                  <td>일시불</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="order-receipt-pay-by">
            <div className="order-receipt-index-wrap">
              <img src={pdfIndexIcon02} alt="결제 방법" />
              <h4 className="order-receipt-index">결제 방법</h4>
            </div>
            <table className="order-receipt-pay-by-table">
              <tbody>
                <tr>
                  <td>카드사</td>
                  <td>0000-****-****-0000</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export const AdminReceiptPdfGenerator = () => {
  const { order_id } = useParams();
  const getPaymentByOrderId = payment((state) => state.getPaymentByOrderId);
  const paymentData = payment((state) => state.payment);
  const isLoading = payment((state) => state.isLoading);
  const cancelPayment = payment((state) => state.cancelPayment);
  const syncPaymentByKey = payment((state) => state.syncPaymentByKey);
  const deleteEnrollment = enrollment((state) => state.deleteEnrollment)
  const getIsEnrolled = enrollment((state)=> state.getIsEnrolled)
  const [isSyncing, setIsSyncing] = useState(false);

  useEffect(() => {
    const fetchPayment = async () => {
      if (order_id) {
        await getPaymentByOrderId(order_id);
      }
    };
    fetchPayment();
  }, [getPaymentByOrderId, order_id]);

  // 이 결제 1건만 토스와 대조해 최신 상태로 맞춘다.
  // 토스 대시보드에서 직접 취소한 경우 등 DB와 실제 상태가 어긋난 건을 즉석에서 확인할 때 사용.
  const handleSyncStatus = async () => {
    if (isSyncing) return;
    const paymentKey = paymentData?.payment_key;
    if (!paymentKey) {
      alert("결제 키 정보가 없습니다. 관리자에게 문의해주세요.");
      return;
    }
    setIsSyncing(true);
    try {
      const res = await syncPaymentByKey(paymentKey);
      if (res?.synced === false) {
        alert(`상태 확인에 실패했습니다.${res?.reason ? `\n(사유: ${res.reason})` : ""}`);
        return;
      }
      if (res?.changed) {
        alert(`결제 상태가 갱신되었습니다.\n${res?.old_status} → ${res?.new_status}`);
        await getPaymentByOrderId(order_id);
      } else {
        alert("이미 최신 상태입니다.");
      }
    } catch (error) {
      console.error("결제 상태 확인 실패:", error);
      alert("상태 확인에 실패했습니다. 잠시 후 다시 시도해 주세요.");
    } finally {
      setIsSyncing(false);
    }
  };

  const handleCancel = async () => {
    const paymentKey = paymentData?.payment_key;
    const purchaserUserId = paymentData?.user_id;
    const purchaserCourseId = paymentData?.course_id;
  
    if (paymentKey) {
      const confirmCancel = window.confirm("정말로 결제를 취소하시겠습니까?");
      if (confirmCancel) {
        try {
          // 결제 취소
          await cancelPayment(paymentKey, "관리자에 의한 결제 취소", paymentData?.amount);

          // 관리자 페이지에서는 취소된 수강도 조회해야 하므로 include_canceled=true
          const enrollmentInfo = await getIsEnrolled(purchaserUserId, purchaserCourseId, {
            includeCanceled: true,
          });

          if (enrollmentInfo && enrollmentInfo.id) {
            if (enrollmentInfo.canceled_at) {
              // 백엔드에서 이미 수강 취소 처리됨
              alert("결제가 취소되었습니다. (수강 정보: 결제 취소됨)");
            } else {
              await deleteEnrollment(enrollmentInfo.id);
              alert("결제가 취소되고 수강 등록이 삭제되었습니다.");
            }
          } else {
            alert("결제는 취소되었지만, 수강 등록 정보를 찾을 수 없습니다.");
          }
        } catch (error) {
          console.error("Error during cancellation process:", error);
          if (error.response && error.response.status === 404) {
            alert("결제 정보를 찾을 수 없습니다.");
          } else if (error.message === "ALREADY_CANCELED_PAYMENT") {
            alert("이미 취소된 결제입니다.");
          } else {
            alert("결제 취소 중 오류가 발생했습니다. 관리자에게 문의해주세요.");
          }
        }
      }
    } else {
      alert("결제 키 정보가 없습니다. 관리자에게 문의해주세요.");
    }
  };

  const getStateClassName = useCallback((state) => {
    const stateClassMap = {
      CANCELED: "결제취소",
      READY: "결제중",
      DONE: "결제완료",
      WAITING_FOR_DEPOSIT: "결제확인", // "입금대기",
      COMPLETED: "결제확인",
      IN_PROGRESS: "처리중",
      PARTIAL_CANCELED: "부분취소",
      ABORTED: "실패",
      EXPIRED: "만료"
    };
    return stateClassMap[state] || "";
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="admin-order-title-wrap">
        <div className="admin-order-price-state">
          <h2 className="admin-order-title">{paymentData?.amount}원</h2>
          <div
            className={`admin-order-item-state ${paymentData?.status}`}
          >
            {getStateClassName(paymentData?.status) || paymentData?.status}
          </div>
        </div>
        <div className="admin-order-buttons">
          {/* <Button
            label="영수증 보내기"
            onClick={() => receiptPDF(order_id)}
            style={{
              height: "36px",
              padding: "auto 16px",
              fontSize: "14px",
            }}
          ></Button>*/}
          <Button
            label={isSyncing ? "확인 중..." : "상태 확인"}
            variant="secondary"
            className={isSyncing ? "disabled" : ""}
            style={{
              height: "36px",
              padding: "auto 16px",
              fontSize: "14px",
              ...(isSyncing ? { opacity: 0.5, pointerEvents: "none" } : {}),
            }}
            onClick={handleSyncStatus}
          ></Button>
          <Button
            label="환불 하기"
            style={{ height: "36px", padding: "auto 16px", fontSize: "14px" }}
            onClick={handleCancel}
          ></Button>
        </div>
      </div>
      {paymentData?.status && STATUS_DESCRIPTION[paymentData.status] && (
        <div
          className="admin-order-status-note"
          style={{
            margin: "0 0 16px",
            padding: "12px 16px",
            borderRadius: "8px",
            background: "#171a1f",
            border: "1px solid #2a2f37",
            color: "#dee1e6",
            fontSize: "14px",
            lineHeight: 1.6,
          }}
        >
          <p style={{ margin: 0 }}>
            <strong>
              {getStateClassName(paymentData.status) || paymentData.status}
            </strong>
            {" — "}
            {STATUS_DESCRIPTION[paymentData.status]}
          </p>
          {/* fail_code/fail_reason/failed_at는 백엔드 추가 예정 필드로,
              존재할 때만 노출한다(현재는 값이 없어 렌더되지 않음). */}
          {(paymentData.fail_reason ||
            paymentData.fail_code ||
            paymentData.failed_at) && (
            <ul style={{ margin: "8px 0 0", paddingLeft: "18px" }}>
              {paymentData.fail_reason && (
                <li>실패 사유: {paymentData.fail_reason}</li>
              )}
              {paymentData.fail_code && (
                <li>실패 코드: {paymentData.fail_code}</li>
              )}
              {paymentData.failed_at && (
                <li>
                  실패 시각: {new Date(paymentData.failed_at).toLocaleString()}
                </li>
              )}
            </ul>
          )}
        </div>
      )}
      <div className="admin-order-receipt-wrap">
        <div
          className="admin-order-receipt"
          id={`admin-order-receipt-${order_id}`}
        >
          <div className="admin-order-receipt-info">
            <div className="admin-order-receipt-index-wrap">
              <img src={pdfIndexIcon01} alt="결제 방법" />
              <h4 className="admin-order-receipt-index">결제 정보</h4>
            </div>
            <table className="admin-order-receipt-info-table">
              <tbody>
                <tr>
                  <td>결제금액</td>
                  <td>{paymentData?.amount}</td>
                </tr>
                <tr>
                  <td>부가세</td>
                  <td>{(paymentData?.amount * 0.1).toFixed(0)}</td>
                </tr>
                <tr>
                  <td>할인액</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td className="admin-order-receipt-info-value-strong">
                    {paymentData?.amount}
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td>결제일</td>
                  <td>{new Date(paymentData?.created_at).toLocaleString()}</td>
                </tr>
                <tr>
                  <td>구매자</td>
                  <td>{paymentData?.user_name}</td>
                </tr>
                <tr>
                  <td>결제번호</td>
                  <td>#{paymentData?.payment_id}</td>
                </tr>
                <tr>
                  <td>할부</td>
                  <td>일시불</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="admin-order-receipt-pay-by">
            <div className="admin-order-receipt-index-wrap">
              <img src={pdfIndexIcon02} alt="결제 방법" />
              <h4 className="admin-order-receipt-index">결제 방법</h4>
            </div>
            <table className="admin-order-receipt-pay-by-table">
              <tbody>
                <tr>
                  <td>카드사</td>
                  <td>0000-****-****-0000</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
